import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  infoIcon: {
    height: theme.spacing(2),
    width: theme.spacing(2),
    fontSize: '16px',
  },
  qAndAParentWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  sidePanelInfoIcon: {
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
    fontSize: '20px',
    color: `var(--M3-light-on-primary, ${theme.palette.labraText.primary})`,
  },
  sidePanelTitleText: {
    fontSize: '22px',
    lineHeight: '28px',
    color: `var(--M3-light-on-primary, ${theme.palette.labraText.primary})`,
    marginLeft: theme.spacing(0.5),
  },
  horizontalDivider: {
    backgroundColor: theme.palette.dividerV2.main,
    width: '100%',
    minWidth: theme.spacing(77.5),
    height: theme.spacing(0.125),
    marginTop: theme.spacing(-1),
    borderRadius: theme.spacing(0.5),
  },
  question: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontFamily: theme.typography.fontFamily,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(8),
    marginTop: theme.spacing(1),
  },
  contentWrapper: {
    display: 'flex',
    gap: theme.spacing(1.5),
  },
  qAndAContainer: {
    width: 'fit-content',
    display: 'flex',
    gap: theme.spacing(1),
    flexDirection: 'column',
  },
  qAndAWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(5),
    marginTop: theme.spacing(-4),
  },
  answerText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    fontFamily: theme.typography.fontFamily,
    color: `var(--M3-light-on-primary, ${theme.palette.labraText.tertiary})`,
  },
  questionText: {
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.primary,
  },
  header: {
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '27px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.primary,
    marginBottom: theme.spacing(5.5),
  },
}))
